/* src/app/features/prestacao-informacoes/acompanhamento-depr/acompanhamento-depr-pesquisa/acompanhamento-depr-pesquisa.component.scss */
/*# sourceMappingURL=acompanhamento-depr-pesquisa.component.css.map */
